import { Box, Container, Link, Typography } from "@mui/material";

export const NoAccessPage = ({message=''}) => {

  return (
    <>
      <Box 
        sx={{ 
          display: 'flex'
        }} 
        alignItems="center" 
        justifyContent="center"
        my={6}
      >
        <Container maxWidth="md">
          <Typography variant="h2" align="center" mb={4}>Oops! You do not have access to this page.</Typography>
          {message && 
            <Typography variant="h3" align="center" mb={4}>{message}</Typography>
          }
          <Typography variant="subtitle1" align="center">
            If you need assistance, please <Link href="mailto:asc@alumni.ucla.edu" underline="none" target="_blank">email us</Link>. 
          </Typography>
        </Container>
      </Box>
    </>
  );
}

export default NoAccessPage;